const cnpj = require('./cnpj');
const cpf = require('./cpf');
const cep = require('./cep');

module.exports = {
    cnpj,
    cpf,
    cep
}